<template>
  <!-- 基本信息考号 -->
  <!-- //考号填写模式：0-填涂考号， 1-条码 ，2-手写考号 -->
  <div class="basics">
    <template v-if="answerSheet.acCardStudentCodeType == 2">
      <!-- 考号填写模式，2-手写考号 -->
      <div style="width: 100%">
        <BInfo />
      </div>
      <div style="width: 100%">
        <BFullFilling :sty="{ 'border-right': 0, 'border-top': 0 }" />
      </div>

      <div style="width: 100%">
        <BDesc :isCW="false" />
        <!-- <BCardTips v-if="answerSheet.acCardMissSign" /> -->
            <div
          class="c-cont"
          v-if="answerSheet.acCardMissSign && msg.pageIndex == 0"
        >
          <span class="c-t">缺考</span>
          <span class="c-t c-b c-b0"></span>
          <span class="c-t">违纪</span>
          <span class="c-t c-b c-b1"></span>
        </div>
      </div>
    </template>
    <template v-if="answerSheet.acCardStudentCodeType == 1">
      <!-- //考号填写模式： 1-条码 -->
     <template v-if="a1type1">
        <div style="width: 100%">
        <BInfo />
      </div>
      <div style="width: 100%" v-if="answerSheet.acCardPanes == 3">
        <BFullFilling />
      </div>
      <div
        class="box"
        :style="{ width: answerSheet.acCardPanes == 3 ? '100%' : '' }"
      >
        <!-- <BDesc v-if="answerSheet.acCardPanes == 3" :isCW="false" /> -->
        <BDesc v-if="answerSheet.acCardPanes != 3" :isCW="true" style="height: 200px" />
      </div>
      <div class="flex-box" v-if="answerSheet.acCardPanes != 3">
        <BFullFilling />
      </div>
      <div style="width: 100%">
        <!-- <BCardTips v-if="answerSheet.acCardMissSign" /> -->
          <div
          class="c-cont"
          v-if="answerSheet.acCardMissSign && msg.pageIndex == 0"
        >
          <span class="c-t">缺考</span>
          <span class="c-t c-b c-b0"></span>
          <span class="c-t">违纪</span>
          <span class="c-t c-b c-b1"></span>
        </div>
      </div>
     </template>
        <template v-if="a3x1x8type1">
      <div class="box" style="flex-grow: 1">
        <div
          class="c-cont"
          v-if="answerSheet.acCardMissSign && answerSheet.acCardPanes == 3 && msg.pageIndex == 0"
        >
          <span class="c-t">缺考</span>
          <span class="c-t c-b c-b0"></span>
          <span class="c-t">违纪</span>
          <span class="c-t c-b c-b1"></span>
        </div>
        <BInfo
          style="
            height: 100%;
            box-sizing: border-box;
            border-bottom: 1px solid #000;
          "
        />
      </div>
      <div class="box">
        <BFullFilling :sty="{ 'border-left': 0 }" style="height: '100%'" />
      </div>
    </template>
    </template>
    <!-- //以下是考号填写模式：0-填涂考号， -->
    <template v-if="a1x1x10 || a1x11x15">
      <div class="flex-nowrap">
        <div class="box" style="flex-grow: 1">
          <BInfo />
          <BDesc
            :style="{ height: answerSheet.acCardMissSign ? '200px' : '200px' }"
          />
          <!-- <BCardTips v-if="answerSheet.acCardMissSign" /> -->
              <div
          class="c-cont"
          v-if="answerSheet.acCardMissSign && msg.pageIndex == 0"
        >
          <span class="c-t">缺考</span>
          <span class="c-t c-b c-b0"></span>
          <span class="c-t">违纪</span>
          <span class="c-t c-b c-b1"></span>
        </div>
        </div>
        <div class="box">
          <BFullFilling :sty="{ 'border-left': 0 }" />
        </div>
      </div>
    </template>
    <template v-if="a3x1x8">
      <div class="box" style="flex-grow: 1">
        <div
          class="c-cont"
          v-if="answerSheet.acCardMissSign && answerSheet.acCardPanes == 3 && msg.pageIndex == 0"
        >
          <span class="c-t">缺考</span>
          <span class="c-t c-b c-b0"></span>
          <span class="c-t">违纪</span>
          <span class="c-t c-b c-b1"></span>
        </div>
        <BInfo
          style="
            height: 100%;
            box-sizing: border-box;
            border-bottom: 1px solid #000;
          "
        />
      </div>
      <div class="box">
        <BFullFilling :sty="{ 'border-left': 0 }" />
      </div>
    </template>
    <template v-if="a3x9x18">
      <div style="width: 100%">
        <div
          class="c-cont"
          v-if="answerSheet.acCardMissSign && answerSheet.acCardPanes == 3"
        >
          <span class="c-t">缺考</span>
          <span class="c-t c-b c-b0"></span>
          <span class="c-t">违纪</span>
          <span class="c-t c-b c-b1"></span>
        </div>
        <BInfo />
      </div>
      <div style="width: 100%" class="flex-box">
        <BFullFilling
          :sty="{
            'border-right-width':
              answerSheet.acCardExamNumber != 18 ? '0px' : '1px',
            'border-top': 0,
          }"
        />
        <BWrapper
          style="flex-grow: 1; border-top: 0"
          v-if="answerSheet.acCardExamNumber != 18"
        />
      </div>
      <div style="width: 100%">
        <!-- <BDesc :isCW="false" /> -->
        <!-- <BCardTips v-if="answerSheet.acCardMissSign" /> -->
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import BFullFilling from "./BasicsFullFilling";
import BInfo from "./BasicsInfo";
import BDesc from "./BasicsDesc";
import BCardTips from "./BasicsCardTips";
import BWrapper from "./BasicsWrapper";
//基础信息区
export default {
  name: "basics",
  components: {
    BFullFilling,
    BInfo,
    BDesc,
    BCardTips,
    BWrapper,
  },
  props: {
    msg: Object,
  },
  computed: {
    ...mapGetters({
      answerSheet: "answerPanel/answerSheet",
    }),
    ...mapState("cardMake", ["pageCellSize"]), //答卷设置参数
    a1x1x10() {
      if (
        this.answerSheet.acCardStudentCodeType == 0 &&
        this.answerSheet.acCardPanes != "3" &&
        this.answerSheet.acCardExamNumber < 11
      ) {
        return true;
      } else {
        return false;
      }
    }, //一栏二栏考号1-10位的验证
    a1x11x15() {
      if (
        this.answerSheet.acCardStudentCodeType == 0 &&
        this.answerSheet.acCardPanes != "3" &&
        this.answerSheet.acCardExamNumber > 10 &&
        this.answerSheet.acCardExamNumber < 16
      ) {
        return true;
      } else {
        return false;
      }
    }, //一栏二栏考号11-15位的验证
    a1x16x18() {
      if (
        this.answerSheet.acCardStudentCodeType == 0 &&
        this.answerSheet.acCardPanes != "3" &&
        this.answerSheet.acCardExamNumber > 15
      ) {
        return true;
      } else {
        return false;
      }
    }, //一栏二栏考号16-18位的验证
    a3x1x8() {
      if (
        this.answerSheet.acCardStudentCodeType == 0 &&
        this.answerSheet.acCardPanes == "3" &&
        this.answerSheet.acCardExamNumber <= 12
      ) {
        return true;
      } else {
        return false;
      }
    }, //三栏考号1-8位的验证
    a1type1() {
    if (
        this.answerSheet.acCardStudentCodeType == 1 &&
        this.answerSheet.acCardPanes != "3" 
      ) {
        return true;
      } else {
        return false;
    }
    },
     a3x1x8type1() {
      if (
        this.answerSheet.acCardStudentCodeType == 1 &&
        this.answerSheet.acCardPanes == "3" 
      ) {
        return true;
      } else {
        return false;
      }
    }, //三栏考号1-8位的验证
    a3x9x18() {
      if (
        this.answerSheet.acCardStudentCodeType == 0 &&
        this.answerSheet.acCardPanes == "3" &&
        this.answerSheet.acCardExamNumber > 12
      ) {
        return true;
      } else {
        return false;
      }
    }, //三栏考号9-18位的验证
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.basics {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  // font-family: Times,"Times New Roman",SimSun-ExtB,SimSun,NSimSun,serif;

  .flex-box {
    display: flex;
    flex-wrap: wrap;
  }
  .flex-nowrap {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
  }
  .c-cont {
    position: absolute;
    right: 50px;
    top: 17px;
    padding-top: 20px;
    padding-left: 10px;
  }
  .c-t {
    margin-right: 10px;
    display: inline-block;
    &:nth-child(3) {
      margin-left: 20px;
    }
  }
  .c-b {
    width: 18px;
    height: 8px;
    border: 1px solid #000000;
  }
}
</style>
